module.exports = __webpack_public_path__ + "assets/img/times-of-india.a8d15812.jpg";